// removed by extract-text-webpack-plugin
module.exports = {"page":"_3EdRCYAK5P_C3NsUqb6eyw","intro":"_2k0AHOsrMjsglFfonBSg4Y","particlesStyle":"_3CIQjbDgTYM8bSJnAVjVTc","inTheParticles":"_2G3K4PcMjDvH5dk6C0gypE","link":"iyHfn9ewPD0K89g93iJiK"};


//////////////////
// WEBPACK FOOTER
// ./styles.module.css
// module id = 418
// module chunks = 0